export default "__VITE_ASSET__B1M3qF35__"